const projects = [
    {
        title: "Groundnut Seeding Machine with IoT for Small-Scale Agriculture",
        role: "Team Lead",
        description: "Led the development of an innovative groundnut seeding machine designed to replicate traditional tools. Implemented an IoT-based workflow with image processing for real-time monitoring and improved seeding accuracy, enhancing agricultural efficiency for small-scale farmers.",
        duration: "Sept 2022 - April 2023"
    },
    {
        title: "AI-Based Interactive Chatbot for the Department of Justice’s Website using RAG",
        role: "Backend Developer",
        description: "Developed the backend for an interactive legal chatbot using Retrieval-Augmented Generation (RAG). Integrated LLM APIs via FastAPI to handle user queries and deliver accurate, context-aware responses efficiently.",
        duration: "Aug 2024 - Sept 2024"
    },
    {
        title: "Detecting Signs of Depression from Social Media Text",
        role: "Team Lead",
        description: "Applied machine learning and natural language processing techniques to analyze social media posts for early indicators of depression. Designed predictive models to assist in mental health screening and early intervention.",
        duration: "Mar 2023 - Jun 2023"
    },
    {
        title: "Empowering the Handloom Industry Through Embedded IoT Systems",
        role: "Team Lead",
        description: "Designed and implemented an embedded IoT system for remotely loading design patterns into power looms. Integrated Business Intelligence (BI) tools for real-time analysis of machine performance and output metrics.",
        duration: "Jul 2023 - May 2024"
    },
    {
        title: "Analyzing Early-Stage Alzheimer's Disease from EEG Recordings",
        role: "Team Lead",
        description: "Collected EEG data from 100 participants across age groups and evaluated their memory recall through story-based tasks. Performed signal analysis to identify potential early markers of Alzheimer's disease.",
        duration: "Jan 2024 - Dec 2024"
    },
    {
        title: "Multimodal Hate Speech Detection in Dravidian Languages",
        role: "Team Lead",
        description: "Developed a multimodal deep learning system to detect hate speech in Dravidian languages using both audio and text data from social media. Enhanced detection accuracy by leveraging cross-modal correlations and language-specific nuances.",
        duration: "Jan 2025 - April 2025"
    }
];

export default projects;